import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'wil-wheel-history',
  standalone: true,
  imports: [MatIcon, BaseChartDirective],
  templateUrl: './wheel-history.component.html',
  styleUrl: './wheel-history.component.scss',
})
export class WheelHistoryComponent {
  private readonly dialogRef = inject(MatDialogRef<WheelHistoryComponent>);

  public data: ChartConfiguration['data'] = {
    labels: ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Health',
        fill: false,
        backgroundColor: '#ff6b6b',
        borderColor: '#ff6b6b',
        data: [3, 5, 5, 6, 7, 4, 5, 6, 8, 7, 7, 8],
        borderWidth: 1,
      },
      {
        label: 'Career',
        fill: false,
        backgroundColor: '#4ecdc4',
        borderColor: '#4ecdc4',
        data: [6, 7, 7, 8, 7, 7, 6, 8, 7, 6, 7, 6],
        borderWidth: 1,
      },
      {
        label: 'Relationships',
        fill: false,
        backgroundColor: '#fff',
        borderColor: '#45b7d1',
        data: [4, 5, 6, 6, 4, 7, 5, 7, 4, 5, 6, 7],
        borderDash: [10, 10],
        borderWidth: 5,
      },
      {
        label: 'Finances',
        fill: false,
        backgroundColor: '#fff',
        borderColor: '#f9ca24',
        data: [3, 2, 5, 5, 4, 6, 6, 4, 5, 6, 7, 6],
        borderDash: [10, 10],
        borderWidth: 5,
      },
      {
        label: 'Personal Growth',
        fill: false,
        backgroundColor: '#6c5ce7',
        borderColor: '#6c5ce7',
        data: [5, 6, 7, 7, 3, 3, 4, 5, 6, 6, 4, 6],
        borderWidth: 1,
      },
      {
        label: 'Recreation',
        fill: false,
        backgroundColor: '#a29bfe',
        borderColor: '#a29bfe',
        data: [7, 4, 6, 4, 9, 8, 5, 7, 6, 8, 6, 7],
        borderWidth: 1,
      },
    ],
  };

  public options: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Lauren Hue',
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Month',
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Value',
        },
      },
    },
  };

  public onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
